export const facebookStatisticsGroups = [
  {
    label: 'Общие',
    options: [{value: 'traffic_type', label: 'Тип трафика'}],
  },
  {
    label: 'Facebook',
    options: [
      {value: 'traffic', label: 'Кампания'},
      {value: 'source', label: 'Поток'},
      {value: 'pixel', label: 'Пиксель'},
      {value: 'bayer', label: 'Байер'},
    ],
  },
  {
    label: 'Партнеры',
    options: [
      {value: 'advertiser', label: 'Рекламодатель'},
      {value: 'brand', label: 'Бренд'},
      {value: 'country', label: 'Гео'},
      {value: 'offer', label: 'Оффер'},
      {value: 'landing', label: 'Лендинг'},
    ],
  },
  {
    label: 'Приложения',
    options: [
      {value: 'app', label: 'Приложение'},
      {value: 'app_service', label: 'Сервис'},
      {value: 'app_type', label: 'Платформа'},
    ],
  },
  {
    label: 'Телеграм',
    options: [
      {value: 'bot', label: 'Бот'},
      {value: 'channel', label: 'Канал'},
      {value: 'tg_account', label: 'Телеграм Аккаунт'},
      {value: 'channel_group', label: 'Группа Каналов'},
    ],
  },
  {
    label: 'Дата',
    options: [
      {value: 'day', label: 'День'},
      {value: 'month', label: 'Месяц'},
      {value: 'year', label: 'Год'},
    ],
  },
];
